import React from 'react';
import Responsive from '@frontend/jetlend-web-ui/src/utils/responsive';
import BannerSection from '@app/features/academy/guest_main/BannerSection/BannerSection';
import MainSection from '@app/features/academy/guest_main/MainSection/MainSection';
import SpeakerSection from '@app/features/academy/guest_main/SpeakerSection/SpeakerSection';
import PromotionSection from '@app/features/academy/guest_main/MainSection/PromotionSection/PromotionSection';
import PromotionCourseSection from '@app/features/academy/main/FooterSection/PromotionCourseSection/PromotionCourseSection';
import Section from '@app/ui/Section/Section';
import {
    IAcademySpeakerApiModel,
    IAchievementItemApiModel,
    ICourseInformationApiModel,
    IPromotionCourseApiModel,
} from '@app/models/features/course';
import { IBasePageApiModel } from '@app/models/common/pages';

import styles from './page.module.scss';

export interface IProps {
    /**
     * Доп поля страницы
     */
    pageModel: IBasePageApiModel;
    /**
    * Список ачивок
    */
    achievements: IAchievementItemApiModel[];
    /**
    * Список всех курсов
    */
    courses: ICourseInformationApiModel[];
    /**
    * Список спикеров
    */
    speakers: IAcademySpeakerApiModel[];
    /**
     * Информация о рекламном курсе
     */
    promotionCourse: IPromotionCourseApiModel;
}

/**
 * Страница академии гостя
 */
const GuestsMainPage = (props: IProps) => {
    const {
        pageModel,
        achievements,
        courses,
        speakers,
        promotionCourse,
    } = props;
    const hero = pageModel?.fields?.hero;
    const blocks = pageModel?.fields?.blocks;

    return (
        <div className={styles['academy-guest']}>
            <BannerSection
                title={hero?.title}
                description={hero?.description}
                imageUrl={pageModel?.preview_url}
                imageAlt={pageModel?.preview_alt}
                blocks={blocks}
            />
            <MainSection
                blocks={blocks}
                achievements={achievements}
                courses={courses}
            />
            <PromotionSection promotionCourse={promotionCourse} />
            {speakers && <SpeakerSection className={styles['speakers']} speakers={speakers} title="Спикеры и эксперты" />}
            {promotionCourse && (
                <Responsive
                    mobile={(
                        <Section className={styles['promotion-course-mobile']} animation={false}>
                            <PromotionCourseSection
                                promotionCourse={promotionCourse}
                                buttonText="Зарегистрироваться"
                                buttonUrl="/invest/register/?return_uri=/academy"
                            />
                        </Section>
                    )}
                />
            )}
        </div>
    );
};

export default GuestsMainPage;
